import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Modal, Input, Select, Radio, Typography, Row, Col, message } from 'antd';
import { useTranslation } from 'react-i18next';
import WizardProgress from './WizardProgress';
import SchemasTable from '../self/schemas/SchemasTable';
import SchemasFormModal from '../self/schemas/SchemasFormModal';
import StatusUpdate from '../utils/StatusUpdate';
import './WizardLayout.css';
import { get_all_self_schemas, self_schema_status_update } from '../../redux/actions/selfSchemasActions';
import { load_self } from '../../redux/actions/selfActions';
import { get_load_status_desc } from '../../utils/get_status_desc';
import { get_load_status_color } from '../../utils/get_color_status';

const { Option } = Select;

const WizardSchemas = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [messageApi, contextHolder] = message.useMessage();

	const { all_self_schemas, all_self_schemas_loading, self_schema_status_history, self_schema_status_history_loading } = useSelector(state => state.self_schemas);

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [update, setUpdate] = useState(false);
	const [schemaToUpdate, setSchemaToUpdate] = useState({});
	const [openStatusUpdate, setOpenStatusUpdate] = useState(false);
	const [pageSize] = useState(0);
	const [skip, setSkip] = useState(0);
	const [loadingSelf, setLoadingSelf] = useState(false);

	// Get wizard state from localStorage
	const [wizardState] = useState(() => JSON.parse(localStorage.getItem('wizardState') || '{}'));

	// Create orgFilters object for the existing components using IDs
	const orgFilters = {
		organization: wizardState.organization?.id || '',
		workspace: wizardState.workspace?.id || '',
		module: wizardState.module?.id || ''
	};

	useEffect(() => {
		if (wizardState.organization?.id) {
			const filters = {
				organization: wizardState.organization.id,
				workspace: wizardState.workspace?.id || '',
				module: wizardState.module?.id || '',
				skip: 0,
				limit: 0
			};
			dispatch(get_all_self_schemas(filters));
		}
	}, [dispatch, wizardState.organization?.id, wizardState.workspace?.id, wizardState.module?.id]);

	// Get names directly from stored wizard state
	const orgName = wizardState.organization?.name || 'None';
	const workspaceName = wizardState.workspace?.name || 'None';
	const moduleName = wizardState.module?.name || 'None';

	const createSchema = () => {
		setIsModalOpen(true);
		setUpdate(false);
		setSchemaToUpdate({});
	};

	const handleContinue = () => {
		setLoadingSelf(true);
		dispatch(load_self(() => {
			setLoadingSelf(false);
			navigate('/wizard/cycles');
		}, () => {
			setLoadingSelf(false);
		}));
	};

	const handleBack = () => {
		navigate('/wizard/start');
	};

	const handleStatusUpdateCancel = () => {
		setOpenStatusUpdate(false);
		setSchemaToUpdate({});
	};

	const changeStatus = (status) => {
		const filters = { ...orgFilters, skip: 0, limit: 0 };
		dispatch(self_schema_status_update(messageApi, schemaToUpdate._id.$oid, status, filters, () => {
			setOpenStatusUpdate(false);
			setSchemaToUpdate({});
		}));
	};


	return (
		<div className="wizard-container">
			{contextHolder}
			<WizardProgress currentStep={1} />

			<div className="content-container" style={{ padding: '40px', maxWidth: '100%', margin: '0 auto' }}>
				<Row justify="space-between" align="top" style={{ marginBottom: '30px' }} gutter={[16, 16]}>
					<Col xs={24} lg={12}>
						<h1 style={{ fontSize: '36px', fontWeight: 'bold', margin: 0 }}>
							PASO 1: DEFINIR LOS ESQUEMAS
						</h1>
					</Col>
					<Col xs={24} lg={12} style={{ textAlign: 'right' }}>
						<Typography.Text>
							<strong>{orgName}</strong>, estás trabajando en el espacio de trabajo <strong>{workspaceName}</strong>, módulo <strong>{moduleName}</strong>.
							<br />
							Si deseas cambiar esta información, regresa al inicio del proceso.
						</Typography.Text>
					</Col>
				</Row>

				<div style={{ marginBottom: '20px' }}>
					<Button
						type="primary"
						icon={<i className="bi bi-plus" />}
						onClick={createSchema}
						style={{ height: '40px', fontSize: '14px' }}
					>
						AGREGAR NUEVO ESQUEMA
					</Button>
				</div>

				{/* <div style={{
					backgroundColor: 'white',
					borderRadius: '8px',
					overflow: 'hidden',
					boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
				}}> */}
					<SchemasTable
						messageApi={messageApi}
						orgFilters={orgFilters}
						setIsModalOpen={setIsModalOpen}
						setUpdate={setUpdate}
						setSchemaToUpdate={setSchemaToUpdate}
						setOpenStatusUpdate={setOpenStatusUpdate}
						pageSize={pageSize}
						skip={skip}
						setSkip={setSkip}
					/>
				{/* </div> */}

				<Row justify="space-between" style={{ marginTop: '40px' }}>
					<Col>
						<Button
							size="large"
							onClick={handleBack}
							style={{ height: '50px', fontSize: '16px', minWidth: '120px' }}
						>
							← REGRESAR
						</Button>
					</Col>
					<Col>
						<Button
							type="primary"
							size="large"
							loading={loadingSelf}
							onClick={handleContinue}
							style={{ height: '50px', fontSize: '16px', minWidth: '150px' }}
						>
							CONTINUAR →
						</Button>
					</Col>
				</Row>
			</div>

			<SchemasFormModal
				messageApi={messageApi}
				isModalOpen={isModalOpen}
				setIsModalOpen={setIsModalOpen}
				orgFilters={orgFilters}
				update={update}
				schemaToUpdate={schemaToUpdate}
				setSchemaToUpdate={setSchemaToUpdate}
				pageSize={pageSize}
				skip={skip}
			/>

			<StatusUpdate
				openModal={openStatusUpdate}
				handleCancel={handleStatusUpdateCancel}
				loadingHistory={self_schema_status_history_loading}
				statusHistory={self_schema_status_history}
				statusDescriptions={get_load_status_desc}
				statusColors={get_load_status_color}
				statusQty={9}
				changeStatus={changeStatus}
			/>
		</div>
	);
};

export default WizardSchemas;